module.exports = __webpack_public_path__ + "static/media/user.25d2b1b1.jpg";